import { render, staticRenderFns } from "./editPurchaseInfo.vue?vue&type=template&id=36c1b6dc&"
import script from "./editPurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./editPurchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./editPurchaseInfo.vue?vue&type=style&index=0&id=36c1b6dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports